import React, { useRef, useCallback, useEffect } from 'react';
import './MiniRichEditor.css';

const MiniRichEditor = ({ value, onChange, placeholder, rows = 3 }) => {
  const editorRef = useRef(null);
  const isInternalChange = useRef(false);

  useEffect(() => {
    if (editorRef.current && !isInternalChange.current) {
      if (editorRef.current.innerHTML !== (value || '')) {
        editorRef.current.innerHTML = value || '';
      }
    }
    isInternalChange.current = false;
  }, [value]);

  const handleInput = useCallback(() => {
    if (editorRef.current) {
      isInternalChange.current = true;
      onChange(editorRef.current.innerHTML);
    }
  }, [onChange]);

  const exec = useCallback((command, val = null) => {
    editorRef.current?.focus();
    document.execCommand(command, false, val);
    handleInput();
  }, [handleInput]);

  const handleFontSize = useCallback((e) => {
    const size = e.target.value;
    editorRef.current?.focus();
    // execCommand fontSize uses 1-7 scale, so we use insertHTML instead
    const sel = window.getSelection();
    if (sel.rangeCount > 0 && !sel.isCollapsed) {
      const range = sel.getRangeAt(0);
      const span = document.createElement('span');
      span.style.fontSize = size + 'px';
      span.appendChild(range.extractContents());
      range.insertNode(span);
      // Restore selection
      sel.removeAllRanges();
      const newRange = document.createRange();
      newRange.selectNodeContents(span);
      sel.addRange(newRange);
    }
    handleInput();
  }, [handleInput]);

  const minHeight = rows * 22;

  return (
    <div className="mini-rich-editor">
      <div className="mini-rich-toolbar">
        <button type="button" title="Negrita" onMouseDown={(e) => { e.preventDefault(); exec('bold'); }}>
          <b>B</b>
        </button>
        <button type="button" title="Cursiva" onMouseDown={(e) => { e.preventDefault(); exec('italic'); }}>
          <i>I</i>
        </button>
        <button type="button" title="Subrayado" onMouseDown={(e) => { e.preventDefault(); exec('underline'); }}>
          <u>U</u>
        </button>
        <div className="mini-rich-separator" />
        <select
          title="Tamaño de fuente"
          defaultValue=""
          onChange={(e) => { handleFontSize(e); e.target.value = ''; }}
          onMouseDown={(e) => e.preventDefault()}
        >
          <option value="" disabled>Tamaño</option>
          <option value="8">8px</option>
          <option value="9">9px</option>
          <option value="10">10px</option>
          <option value="11">11px</option>
          <option value="12">12px</option>
          <option value="14">14px</option>
          <option value="16">16px</option>
          <option value="18">18px</option>
        </select>
        <div className="mini-rich-separator" />
        <button type="button" title="Alinear izquierda" onMouseDown={(e) => { e.preventDefault(); exec('justifyLeft'); }}>
          ≡
        </button>
        <button type="button" title="Centrar" onMouseDown={(e) => { e.preventDefault(); exec('justifyCenter'); }}>
          ≡
        </button>
        <button type="button" title="Alinear derecha" onMouseDown={(e) => { e.preventDefault(); exec('justifyRight'); }}>
          ≡
        </button>
      </div>
      <div
        ref={editorRef}
        className="mini-rich-content"
        contentEditable
        onInput={handleInput}
        data-placeholder={placeholder}
        style={{ minHeight: minHeight + 'px' }}
      />
    </div>
  );
};

export default MiniRichEditor;
